import type { AnnotationStore, TranscriptionAnnotation } from '../../../transcription/types/annotation';
import type { CastedValue, ResolvedValues } from '../../type/common/types';
import type { TranscriptionAnnotationResolver } from '../../type/transcription-resolver';
import { QaCheckError, QaCheckErrorCode } from '../../utils/error';
import { castToRequiredType } from '../common/cast';
export const resolveTranscriptionData = (annotationResolver: TranscriptionAnnotationResolver, annotationStore: AnnotationStore): QaCheckError | ResolvedValues<'ANNOTATION'> => {
  const label = annotationResolver.filter.label;
  const annotationsWithSelectedLabel = Object.entries(annotationStore).filter(([, annotation]) => annotation.annotationLabel.title === label).map(([id, annotation]) => ({
    id,
    annotation
  }));
  if (annotationsWithSelectedLabel.length === 0) {
    return [];
  }
  const allResolvedData: ResolvedValues<'ANNOTATION'> = [];
  for (const {
    annotation,
    id
  } of annotationsWithSelectedLabel) {
    const resolvedDataForAnnotation = getResolvedDataForAnnotation(annotationResolver, annotation);
    if (resolvedDataForAnnotation instanceof QaCheckError && resolvedDataForAnnotation.code === QaCheckErrorCode.missingFields) {
      continue;
    }
    if (resolvedDataForAnnotation instanceof QaCheckError) {
      return resolvedDataForAnnotation;
    }
    allResolvedData.push({
      values: resolvedDataForAnnotation,
      metadata: {
        type: 'ANNOTATION',
        id
      }
    });
  }
  return allResolvedData;
};
const getResolvedDataForAnnotation = (annotationResolver: TranscriptionAnnotationResolver, annotation: TranscriptionAnnotation) => {
  const resolvedDataForAnnotation = Object.entries(annotationResolver.resolve).reduce<{
    [subResolver: string]: CastedValue;
  } | QaCheckError>((accumulatedValues, [subAlias, resolver]) => {
    if (accumulatedValues instanceof QaCheckError) {
      return accumulatedValues;
    }
    switch (resolver.extract) {
      case 'ANSWER_VALUES':
        {
          const questionId = resolver.questionId;
          const answers = annotation.metadata?.answers?.[questionId]?.answers;
          if (!answers) {
            return new QaCheckError('No answers found for configured question id', QaCheckErrorCode.missingFields);
          }
          const supportedAnswers = answers.filter(answer => {
            return typeof answer === 'string';
          });
          const destructuredAnswers = supportedAnswers.length === 1 ? supportedAnswers[0] ?? '' : supportedAnswers;
          const castedAnswer = castToRequiredType(resolver.cast, destructuredAnswers);
          accumulatedValues[subAlias] = castedAnswer;
          return accumulatedValues;
        }
      case 'TRANSCRIPT':
        {
          return new QaCheckError('Transcript is unimplemented.', QaCheckErrorCode.unimplemented);
        }
    }
  }, {});
  return resolvedDataForAnnotation;
};